/* eslint-disable react/forbid-prop-types */
import React, { useMemo, useContext } from 'react';
import PropTypes from 'prop-types';
import { InstrumentationContext } from './instrumentation-context';

export const ScenarioContext = React.createContext();

export const Scenario = (props) => {
  const instrumentation = useContext(InstrumentationContext);
  const context = useContext(ScenarioContext);

  const scenarioInstance = useMemo(() => {
    if (props.name) {
      if (context && context.value === props.name) {
        // if parent scenario and current one share the same name
        // reuse parent scenario instance
        return context;
      } else if (instrumentation && instrumentation.createScenario) {
        // otherwise create a new scenario instance and pass in parent scenario instance
        // which could be undefined or null
        return instrumentation.createScenario({
          scenarioName: props.name,
          parentScenario: context,
        });
      }
    }
    return undefined;
  }, [context, instrumentation, props.name]);

  return (
    <ScenarioContext.Provider value={scenarioInstance}>
      {props.children}
    </ScenarioContext.Provider>
  );
};

Scenario.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  name: PropTypes.string.isRequired,
};
